import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import upperCaseFirst from 'upper-case-first';
import Button from './Button';
import OptionsList from './OptionsList';
import * as actions from '../actions';

/**
 * DropDown container
 */
class DropDown extends Component {
    componentDidMount() {
        this.props.onMount();
        document.addEventListener('click', this.handleClickOutside.bind(this), true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    getSelectedDisplayName() {
        const option = this.props.options.find(el => el.value === this.props.selected);
        if (!option) {
            return this.props.title;
        }

        return option.displayName || upperCaseFirst(option.value);
    }

    handleClickOutside(event) {
        if (this.props.opened) {
            const domNode = this.node.getElementsByClassName('sales__dropdown')[0];
            const filterBtn = this.node.getElementsByClassName('ui-dropdownButton')[0];

            if (!domNode.contains(event.target) && !filterBtn.contains(event.target)) {
                this.props.onClose();
            }
        }
    }

    render() {
        return (
            <div className="sales__dropdownWrapper" ref={node => (this.node = node)}>
                <Button
                    onButtonClick={this.props.onOpen}
                    opened={this.props.opened}
                >
                    {this.getSelectedDisplayName()}
                </Button>
                <OptionsList
                    title={this.props.title}
                    options={this.props.options}
                    opened={this.props.opened}
                    selected={this.props.selected}
                    onOptionClick={this.props.onOptionSelect}
                    onCancelClick={this.props.onClose}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const props = _.get(state, ownProps.stateKey).dropDown;

    return {
        opened: props.opened,
        selected: props.selected
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onMount: () => dispatch(
            actions.defaults(
                ownProps.stateKey,
                ownProps.defaultValue,
                ownProps.onSelect(ownProps.name, ownProps.defaultValue)
            )
        ),

        onOptionSelect: value => dispatch(
            actions.select(
                ownProps.stateKey,
                value,
                ownProps.onSelect(ownProps.name, value)
            )
        ),

        onOpen: () => dispatch(
            actions.toggle(ownProps.stateKey)
        ),

        onClose: () => dispatch(
            actions.close(ownProps.stateKey)
        )
    };
}

DropDown.propTypes = {
    // Own props
    stateKey: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    onSelect: PropTypes.func,

    // State props
    opened: PropTypes.bool,
    selected: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),

    // Dispatch props
    onMount: PropTypes.func,
    onOptionSelect: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(DropDown);



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/components/index.js